export default function formatExperimentName(name: string | undefined | null): string {
  return name || "New untitled experiment";
}
